<template>
  <div>
    <comment-form-modal
      ref="modal"
      :pending="pending"
      :parent="parent"
      @submitted="$emit('submitted', $event)"
      @closed="$emit('closed')"
    />

    <template v-if="!mobileView && (formActive || active)">
      <comment-form
        ref="form"
        :comment="comment"
        :pending="pending"
        @submitted="$emit('submitted', $event)"
      />
    </template>
  </div>
</template>

<script>
import { Breakpoint } from "@/utils/browser/breakpoint";

import CommentForm from "./CommentForm";
import CommentFormModal from "./CommentFormModal";

export default {
  components: {
    CommentForm,
    CommentFormModal,
  },
  props: ["active", "formActive", "comment", "pending", "parent"],

  data() {
    return {
      breakpoint: Breakpoint("(min-width: 768px)"),
      mobileView: false,
    };
  },

  watch: {
    mobileView(v) {
      if (v && this.active) {
        this.$refs.modal.open(this.comment);
      } else if (!v) {
        this.$refs.modal.close();
      }
    },

    active(v) {
      if (v && this.mobileView) {
        this.$refs.modal.open(this.comment);
      }
    },
  },

  created() {
    this.breakpoint.subscribe((isActive) => {
      this.mobileView = !isActive;
    });
  },

  beforeUnmount() {
    this.breakpoint.dispose();
  },

  methods: {
    reset() {
      if (this.mobileView) this.$refs.modal.close();
      else this.$refs.form.reset();
    },
  },
};
</script>
